import { createSlice } from '@reduxjs/toolkit';

export interface ManualSaleState {
    fetching: string;
    transaction: any;
    error: string | null;
    locations: {
        fetching: string;
        data: any[];
    };
    inspectionPoints: {
        fetching: string;
        data: any[];
    };
}

const initialState: ManualSaleState = {
    fetching: "",
    transaction: null,
    error: null,
    locations: {
        fetching: "unknown",
        data: []
    },
    inspectionPoints: {
        fetching: "unknown",
        data: []
    }
};

const manualSaleSlice = createSlice({
    name: 'manualSale',
    initialState,
    reducers: {
        createManualSaleRequest: (state) => {
            state.fetching = "loading";
            state.transaction = null;
            state.error = null;
        },
        createManualSaleSuccess: (state, action) => {
            state.fetching = "success";
            state.transaction = action.payload;
        },
        createManualSaleFailure: (state, action) => {
            state.fetching = "failure";
            state.error = action.payload;
        },
        cleanCreateManualSale: (state) => {
            state.fetching = "";
            state.transaction = null;
            state.error = null;
        },
        getInspectionLocationsRequest: (state) => {
            state.locations.fetching = "loading";
        },
        getInspectionLocationsSuccess: (state, action) => {
            state.locations.fetching = "success";
            state.locations.data = action.payload;
        },
        getInspectionLocationsFailure: (state) => {
            state.locations.fetching = "failure";
            state.locations.data = [];
        },
        getInspectionPointsRequest: (state) => {
            state.inspectionPoints.fetching = "loading";
        },
        getInspectionPointsSuccess: (state, action) => {
            state.inspectionPoints.fetching = "success";
            state.inspectionPoints.data = action.payload;
        },
        getInspectionPointsFailure: (state) => {
            state.inspectionPoints.fetching = "failure";
            state.inspectionPoints.data = [];
        },
        cleanGetInspectionPoints: (state) => {
            state.inspectionPoints.fetching = initialState.inspectionPoints.fetching;
            state.inspectionPoints.data = [];
        }
    }
});

export const {
    createManualSaleRequest,
    createManualSaleSuccess,
    createManualSaleFailure,
    cleanCreateManualSale,
    getInspectionLocationsRequest,
    getInspectionLocationsSuccess,
    getInspectionLocationsFailure,
    getInspectionPointsRequest,
    getInspectionPointsSuccess,
    getInspectionPointsFailure,
    cleanGetInspectionPoints
} = manualSaleSlice.actions;

export default manualSaleSlice.reducer;
